import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { Banner } from "@livechat/design-system";
import { Button, DesignToken, RadiusToken, SpacingToken } from "@livechat/design-system-react-components";

import Flex from "components/layout/Flex";
import { withVar } from "themes/helpers";

export const SetupNameContainer = styled.div`
  padding: var(${SpacingToken.Spacing4});
  border: 1px solid ${withVar(DesignToken.BorderBasicPrimary)};
  border-radius: var(${RadiusToken.Radius3});
`;

export const ModalStyledButton = styled(Button)`
  height: 42px;
  min-height: 42px;
`;

export const StyledButtonMargin = styled(ModalStyledButton)`
  margin-right: 8px;
`;

export const ModalBody = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 100%;

  .first-paragraph {
    font-weight: 600;
    font-size: 24px;
    color: ${withVar(DesignToken.ContentBasicPrimary)};
    margin-top: 16px;
    margin-bottom: 16px;
  }

  .second-paragraph {
    font-weight: 400;
    font-size: 15px;
    color: ${withVar(DesignToken.ContentBasicSecondary)};
    margin-bottom: 40px;
  }
`;

export const IconStyles = css`
  width: 64px;
  height: 64px;
  margin-bottom: 8px;
`;

export const Wrapper = styled.div<{ disabled?: boolean }>`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(${SpacingToken.Spacing2});
  padding: var(${SpacingToken.Spacing5});
  border-radius: var(${RadiusToken.Radius3});
  border: 1px solid
    ${
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
      (props: any) => withVar(props.disabled ? DesignToken.BorderBasicDisabled : DesignToken.BorderBasicPrimary)
    };
  position: relative;

  &:hover {
    border: 1px solid
      ${
        // FIXME: Fix this the next time the file is edited.
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
        (props: any) => withVar(props.disabled ? DesignToken.BorderBasicDisabled : DesignToken.BorderBasicHover)
      };
    cursor: ${
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
      (props: any) => (props.disabled ? "not-allowed" : "pointer")
    };
  }
`;

export const StyledTitle = styled.div`
  display: flex;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 8px;
`;

export const StyledText = styled.div`
  display: flex;
  font-size: 14px;
`;

export const StyledButton = styled(Button)`
  height: 36px;
  min-height: 36px;
`;

export const StyledBanner = styled(Banner)`
  .lc-banner__content-text {
    > strong {
      margin-top: 8px !important;
    }

    > p {
      margin-bottom: 0 !important;
    }
  }
`;

export const LoaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 16px;
  margin-bottom: 16px;
`;

export const SetupStepContainer = styled.div`
  margin: 16px 0;

  > div {
    margin-bottom: 16px;
  }
`;

export const SetupInstructionsContainer = styled.div`
  margin-top: 16px;

  > a {
    margin-bottom: 16px;
    min-height: 36px;
    font-weight: 600;
    font-size: 15px;
    line-height: 20px;
  }

  > p {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: ${withVar(DesignToken.ContentBasicPrimary)};
  }
`;

export const StyledBadge = styled.div`
  min-height: 24px;
  min-width: 24px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(${DesignToken.ContentBasicPrimary});
  background-color: var(${DesignToken.SurfaceModerateDefault});
  margin-right: var(${SpacingToken.Spacing3});
`;

export const ErrorParagraph = styled.p`
  margin-top: 32px;
  margin-bottom: 0 !important;
`;

export const DNSHeaderSetupContainer = styled.div`
  display: flex;
  align-items: center;
  border: 1px solid ${withVar(DesignToken.BorderBasicSecondary)};
  border-radius: var(${RadiusToken.Radius3});
  padding: var(${SpacingToken.Spacing4});
  margin-bottom: var(${SpacingToken.Spacing3});
  gap: var(${SpacingToken.Spacing2});
`;

export const DNSSetupContainer = styled.div``;

export const SetupDKIMRecordsContainer = styled.div`
  padding: 16px;
  border: 1px solid ${withVar(DesignToken.BorderBasicPrimary)};
  border-radius: 4px;
`;

export const setupHeaderStyles = css`
  display: flex;
  align-items: center;
  padding-bottom: var(${SpacingToken.Spacing4});
  gap: var(${SpacingToken.Spacing2});
`;

export const noteStyles = css`
  margin-top: 8px !important;
  margin-bottom: 0 !important;
  color: ${withVar(DesignToken.ContentBasicSecondary)} !important;
`;

export const EmptyTableContainer = styled.div`
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 48px;
  color: ${withVar(DesignToken.ContentBasicPrimary)};

  > h4 {
    margin-top: 16px;
    font-weight: 600;
    font-size: 20px;
  }

  > p {
    margin: 16px 0;
    font-size: 15px;
  }
`;

export const ConfigurationButtonWrapper = styled(Flex)`
  > p {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: ${withVar(DesignToken.ContentBasicSecondary)};
    margin-left: 8px;
  }
`;

export const failedRecordsParagraphStyles = css`
  margin-top: 10px;
`;

export const failedRecordsListStyles = css`
  font-weight: 600;
  list-style: inside;
  margin-left: 8px;
`;
